import { Block } from "@material-ui/icons";
import React from "react";
import { GoalHistoryBlock } from "../../goal_templates/classes/goal_history_block_class";
import { GoalHistoryTable } from "./GoalHistoryTable";

export const GoalHistoryContainer = ({ DBObject, uuid, t }) => {
  const goalHistorySet = () => {
    if (GoalHistoryBlock.compiledSets().length > 0) {
      return GoalHistoryBlock.compiledSets().map((set) => {
        return (
          <React.Fragment key={uuid()}>
            <GoalHistoryTable
              payload={set.recordBlock}
              DBObject={DBObject}
              uuid={uuid}
              t={t}
              title={set.templateName}
            />
          </React.Fragment>
        );
      });
    } else {
      return <div>{t("views.goals.errors.no_goal_histories_loaded")}</div>;
    }
  };

  return <>{goalHistorySet()}</>;
};
